module.exports = __webpack_public_path__ + "static/media/NickStarke.0afbd668.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2019-speakers/NickStarke.png
// module id = 847
// module chunks = 0